import { render } from "./RockinTags.vue?vue&type=template&id=c2db179c&scoped=true"
import script from "./RockinTags.vue?vue&type=script&lang=js"
export * from "./RockinTags.vue?vue&type=script&lang=js"

import "./RockinTags.vue?vue&type=style&index=0&id=c2db179c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2db179c"]])

export default __exports__